import { API_URL } from '../config';

const getAuthHeader = () => {
  const token = localStorage.getItem('access_token');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

export const loginUser = async (credentials) => {
  try {
    const response = await fetch(`${API_URL}/api/login/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(credentials),
    });

    const responseText = await response.text();

    let data;
    try {
      data = JSON.parse(responseText);
    } catch (e) {
      throw new Error(`Server returned invalid JSON: ${responseText.substring(0, 100)}...`);
    }

    if (!response.ok) {
      throw new Error(data.message || 'Login failed');
    }

    if (data.access) {
      localStorage.setItem('access_token', data.access);
    }

    return data;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

export const registerUser = async (username, email, password, betaAccessCode) => {
  const response = await fetch(`${API_URL}/api/register/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ username, email, password, beta_access_code: betaAccessCode }),
  });
  
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || 'Registration failed');
  }
  
  return response.json();
};

export const checkAuthStatus = async () => {
  try {
    const response = await fetch(`${API_URL}/api/check-auth/`, {
      headers: {
        ...getAuthHeader(),
      },
    });
    return response.ok;
  } catch (error) {
    return false;
  }
};

export const requestPasswordReset = async (email) => {
  const response = await fetch(`${API_URL}/api/password-reset/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email }),
  });

  if (!response.ok) {
    throw new Error('Password reset request failed');
  }

  return response.json();
};

export const resetPassword = async (token, newPassword) => {
  const response = await fetch(`${API_URL}/api/password-reset/confirm/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ token, new_password: newPassword }),
  });

  if (!response.ok) {
    throw new Error('Password reset failed');
  }

  return response.json();
}; 